import React, { useEffect, useState } from 'react';
import {
  TextInput,
  Button,
  Box,
  Group,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';

import ApiLinks from '../../Navlinks/ApiLinks';
import LoaderOverlay from '../../Utilities/LoadingOverLay';
import ImageUploadWithPreview from '../../Utilities/ImageUploadWithPreview';

function AddCategory() {
  const location = useLocation();
  const id = location.state?.id;
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [existingImagePath, setExistingImagePath] = useState(null);

  const form = useForm({
    initialValues: {
      id: '',
      compcode: user?.compcode || '',
      categoryname: '',
    },
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/${ApiLinks.Category_GetById}/${id}/${user.compcode}`
        )
        .then((response) => {
          if (response.data.status && response.data.data.length > 0) {
            const data = response.data.data[0];
            form.setValues({
              id: data.id,
              compcode: data.compcode,
              categoryname: data.categoryname,
            });

            if (data.photo) {
              setExistingImagePath(`${process.env.REACT_APP_IMG_URL}/${data.photo}`);
            }
          }
        })
        .catch((err) => {
          console.error('Error loading category:', err);
        })
        .finally(() => setLoading(false));
    }
  }, [id, user.compcode]);

  const handleSubmit = (values) => {
    if (!values.categoryname.trim()) {
      toast.error('Category name is required.');
      return;
    }

    setLoading(true);
    
    const formData = new FormData();
    formData.append('id', id || 0);
    formData.append('categoryname', values.categoryname);
    formData.append('compcode', user?.compcode || '');
    formData.append('serialno', 0);
    if (selectedFile) {
      formData.append('photo', selectedFile);
    }
    
    const request = id && id !== 0
      ? axios.put(`${process.env.REACT_APP_API_URL}/${ApiLinks.Category_Update}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        })
      : axios.post(`${process.env.REACT_APP_API_URL}/${ApiLinks.Category_Save}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        });

    request.then((res) => {
      if (res.data.status) {
        Swal.fire({
          title: id ? 'Updated!' : 'Created!',
          text: `Category ${id ? 'updated' : 'created'} successfully.`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          navigate('/dashboard/category');
        });
      } else {
        Swal.fire('Error!', res.data.message || 'Failed to save category.', 'error');
      }
    })
      .catch(() => {
        Swal.fire('Error!', 'An error occurred while saving.', 'error');
      })
      .finally(() => setLoading(false));
  };

  if (loading) return <LoaderOverlay />;

  return (
    <Box maw={500} mx="auto" sx={(theme) => ({
      backgroundColor: 'white',
      padding: theme.spacing.xl,
      borderRadius: theme.radius.md,
      boxShadow: theme.shadows.md,
    })}>
      <Group position="apart" mb="md">
        <h2>{id ? 'Edit Category' : 'Create Category'}</h2>
        <Button onClick={() => navigate('/dashboard/category')}>Back</Button>
      </Group>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          label="Name"
          placeholder="Enter name"
          {...form.getInputProps('categoryname')}
        />

        <ImageUploadWithPreview
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          existingImagePath={existingImagePath}
          setExistingImagePath={setExistingImagePath}
          label="Upload Image (16:9 preview)"
          fullWidthPreview={true}
        />

        <Button type="submit" mt="lg" fullWidth>
          {id ? 'Update' : 'Create'}
        </Button>
      </form>
    </Box>
  );
}

export default AddCategory;
